import axios from '@axios';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getComplianceTranscript(ctx, { transcriptId, options }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`v1/compliance/transcript/${transcriptId}`, { params: options })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateComplianceTranscript(ctx, { transcriptId, transcriptData }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`v1/compliance/transcript/${transcriptId}`, transcriptData)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
